import PropTypes from 'prop-types';
import React from 'react';
import { FormattedNumber } from 'react-intl';

import { trlFieldDefaultValue } from '»utils/trlFieldDefaultValue';

import { countDecimalDigits } from './number.helper';
import { TrlNumberStyled } from './TrlNumberFormatted.styles';

export const TrlNumberFormatted = ({
  value,
  decimalDigits,
  startDecorator,
  endDecorator,
  fontFamily,
}) => {
  if (!value || value === trlFieldDefaultValue()) return trlFieldDefaultValue();

  return (
    <span>
      {startDecorator}
      <TrlNumberStyled fontFamily={fontFamily}>
        <FormattedNumber
          value={value}
          maximumFractionDigits={decimalDigits ?? countDecimalDigits(value)}
          minimumFractionDigits={decimalDigits ?? countDecimalDigits(value)}
        />
      </TrlNumberStyled>
      {endDecorator}
    </span>
  );
};

TrlNumberFormatted.propTypes = {
  value: PropTypes.number,
  decimalDigits: PropTypes.number,
  startDecorator: PropTypes.node,
  endDecorator: PropTypes.node,
  fontFamily: PropTypes.string,
};
